import {
  Component,
  OnInit
} from '@angular/core';

import { AppState } from '../app.service';
// import { Title } from './title';
// import { XLargeDirective } from './x-large';

import { TweenMax, TimelineMax } from "gsap";
import * as $ from 'jquery/dist/jquery.min.js';
import { FormsModule, ReactiveFormsModule, FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';

import { BrowserModule, Title }  from '@angular/platform-browser';

@Component({
  /**
   * The selector is what angular internally uses
   * for `document.querySelectorAll(selector)` in our index.html
   * where, in this case, selector is the string 'home'.
   */
  selector: 'news',  // <home></home>
  /**
   * We need to tell Angular's Dependency Injection which providers are in our app.
   */
  providers: [
    Title
  ],
  /**
   * Our list of styles in our component. We may add more to compose many styles together.
   */
  styles: [ require('./news.component.css') ],
  /**
   * Every Angular template is first compiled by the browser before Angular runs it's compiler.
   */
  template: require('./news.component.html')
})
export class NewsComponent implements OnInit {
  /**
   * Set our default values
   */
  public localState = { value: '' };
  public myForm: FormGroup; // our model driven form
  public submitted: boolean; // keep track on whether form is submitted
  map = "assets/img/map2_thin.jpg";
  /**
   * TypeScript public modifiers
   */
  constructor(
    public appState: AppState,
    public title: Title,
    private _fb : FormBuilder,

  ) {}

  public ngOnInit() {
    // console.log('hello `news` component');
    this.title.setTitle("The Tiger Club | News");

     this.myForm = this._fb.group({
            first_name: ['', [<any>Validators.required, <any>Validators.minLength(2)]],
            last_name: ['', [<any>Validators.required, <any>Validators.minLength(2)]],
            email: ['', [<any>Validators.required, <any>Validators.minLength(5)]],
            phone_number: ['', [<any>Validators.required, <any>Validators.minLength(7)]],
            message: ['', [<any>Validators.required, <any>Validators.minLength(20)]]
        });

        

    /**
     * this.title.getData().subscribe(data => this.data = data);
     */
     // $("#main_header").addClass("after_scroll");


    //  var scene = new this.appState.ScrollMagic.Scene({
    //   triggerElement: "#trigger",
    //   duration: 60
    // })
    //   .setTween(TweenMax.to(this.test.nativeElement, 0.5, { y: -40 }))
    //   .addTo(this.appState.controller);


     
  }

  save(data, valid){
    if(valid){
      // console.log("SAVED?");
      $("#the_form").fadeOut();
      $("#thank_you").fadeIn();

      data.name = data.first_name+" "+data.last_name;
      data.title = "News Form";
      data.thanks = "Thank you very much for newsing us, we look forward to responding to your query.";

      //SEND THE EMAIL TO USER --> THANK YOU FOR CONTACT
      var user_body = {
          From: "info@tigerclub.co.uk",
          To: data.email,
          TemplateId: 5523701,
          TemplateModel: data
        };
       console.log("USER SENT HERE ", user_body);

      this.appState.send_email(user_body).subscribe((data: any) => {
          console.log("USER SENT HERE ", data);
        })


      //SEND THE EMAIL TO STAFF
      var staff_body = {
          From: "info@tigerclub.co.uk",
          To: "info@tigerclub.co.uk",
          TemplateId: 5523702,
          TemplateModel: data
        };


        console.log("STAFF SENT HERE ", staff_body);
        this.appState.send_email(staff_body).subscribe((data: any) => {
          console.log("STAFF SENT HERE ", data);
        })


    } else {
      // console.log("FAILED?");
      alert("Please complete all fields in the form.");
    }
  }

  public scrollTo(id){
     $('html, body').animate({
        scrollTop: $("#"+id).offset().top - 80
    }, 1000);
  }

  public submitState(value: string) {
    // console.log('submitState', value);
    this.appState.set('value', value);
    this.localState.value = '';
  }
}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/news/news.component.ts